import { z } from "zod";

export const LadyVideoDto = z.object({
  static: z.string(),
  gif: z.string(),
  id: z.number(),
  isFavorite: z.boolean().optional(),
  isPaid: z.boolean(),
  fileNameUrl: z.string().optional(),
});

export const LadyVideoResponseDto = z.object({
  dataMap: z.object({
    actualDate: z.string(),
    result: z.array(LadyVideoDto),
  }),
});

export type LadyVideoDto = z.infer<typeof LadyVideoDto>;
export type LadyVideoResponseDto = z.infer<typeof LadyVideoResponseDto>;
